import { render, staticRenderFns } from "./app-avatar.vue?vue&type=template&id=65164ee3&"
import script from "./app-avatar.vue?vue&type=script&lang=js&"
export * from "./app-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports